import { useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";

export const useConfirmNavigation = (when, message) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!when) return;

    const handleBeforeRouteChange = (e) => {
      const confirmLeave = window.confirm(message);
      if (!confirmLeave) {
        e.preventDefault();
      }
    };

    // Override window.history.pushState to catch internal navigation
    const originalPush = window.history.pushState;
    window.history.pushState = function (...args) {
      if (when) {
        const confirmLeave = window.confirm(message);
        if (!confirmLeave) return;
        // Reset inputDisabled if user confirms leaving
        localStorage.setItem("inputDisabled", "false");
      }
      return originalPush.apply(this, args);
    };

    return () => {
      window.history.pushState = originalPush;
    };
  }, [when, message, navigate, location]);
};
